let filter = document.querySelector('.blogfilter'),
  filterForm = document.querySelector('.blogfilter form'),
  filterToggle = document.querySelector('.blogfilter__button'),
  filterClose = document.querySelector('.blogfilter__close'),
  postlist = document.querySelector('.postlist'),
  filterFormFields = document.querySelectorAll('.blogfilter form select,.blogfilter__search');

filterToggle && filterToggle.addEventListener('click', (e) => {
  e.preventDefault();
  filter.classList.toggle('blogfilter--show');
})

filterClose && filterClose.addEventListener('click', (e) => {
  e.preventDefault();
  filter.classList.remove('blogfilter--show');
})

const urlParams = new URLSearchParams(window.location.search);
let currentStartParam = urlParams.get('start') || '1';

let currentSearch = "";
let anyCurrentCheckedFilter = Array.from(filterForm.elements)
  .some(e => e.type === 'checkbox' && e.checked);

const hasChanged = () => {
  let anyCheckboxChecked = false;

  for (let i = 0; i < filterForm.elements.length; i++) {
    let e = filterForm.elements[i];

    switch (e.tagName) {
      case 'SELECT':
        if (e.value !== e.children[0].value) return true;
        break;
      case 'INPUT':
        if (e.type === 'checkbox') {
          if (e.checked) {
            anyCheckboxChecked = true;
          }
          if (e.checked && !anyCurrentCheckedFilter) return true;
          if (!e.checked && anyCurrentCheckedFilter) return true;
        }
        break;
    }
  }

  anyCurrentCheckedFilter = anyCheckboxChecked;

  let actualUrlParams = new URLSearchParams(window.location.search);
  let updatedStartParam = actualUrlParams.get('start') || '1';
  if (currentStartParam !== updatedStartParam) {
    currentStartParam = updatedStartParam;
    return true;
  }

  return false;
};

const hasInputChanged = () => {
  let updatedSearch = $("#Form_FilterForm_Search").val();
  if (updatedSearch != currentSearch) {
    currentSearch = updatedSearch
    return true;
  }
  return false;
}


let timeout = null,
  hasInput = false,
  controller = new AbortController();

filterFormFields.forEach(field => {
  $(field).on('change input', (e) => {
    if (field.tagName === 'DIV') return;
    if ($(field).hasClass('blogfilter__search') && !hasInputChanged()) {
      return;
    }
    postlist.classList.add('postlist--searching');
    hasInput = true;

    controller.abort();

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      filterForm.requestSubmit();
    }, 1200);
  })
})

filterForm.addEventListener('submit', e => {
  e.preventDefault();
  requestBlogPosts(e.target);
})

const paginationListeners = () => {
  document.querySelectorAll('.bloglist__pages a').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();

      const url = new URL(link.href);
      const startParam = url.searchParams.get('start');

      const currentUrl = new URL(window.location);
      currentUrl.searchParams.set('start', startParam);
      window.history.pushState({}, '', currentUrl);

      const blogFilter = document.querySelector('.blogfilter');

      if (blogFilter) {
        const blogFilterPosition = blogFilter.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({top: blogFilterPosition - 90, behavior: 'smooth'});
      }

      requestBlogPosts(filterForm);
    });
  });
}

const requestBlogPosts = (form) => {
  postlist.classList.add('postlist--searching');

  controller = new AbortController();

  filter.classList.remove('blogfilter--show');

  const formdata = new URLSearchParams(new FormData(form));
  formdata.append('action_filter', '1');

  let shouldSubmit = hasChanged() || hasInput;

  const urlParams = new URLSearchParams(window.location.search);
  const startParam = urlParams.get('start');
  if (startParam) {
    formdata.append('start', startParam);
  }

  if (shouldSubmit) {
    fetch(form.action, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      method: 'post',
      body: formdata,
      signal: controller.signal
    }).then(async (response) => {
      postlist.innerHTML = await response.text();
      postlist.classList.remove('postlist--searching');
      paginationListeners();
    }).catch(error => error.name !== 'AbortError' && console.error(error))
  } else {
    postlist.classList.remove('postlist--searching');
  }
}

paginationListeners();
//filterForm.requestSubmit();

